export default {
  header: 'Proszę zatwierdź',
  processFlow: 'Przepływ procesu',
  box: 'Skrzynka',
  prio: 'Prio',
  testLoad: 'Ładunek testowy',
};
